import { c as _c } from "react/compiler-runtime";
import { ExpandedSearchResultSection } from "../ExpandedSearchResultSection";
export const SECTION_NAME_MAPPING = {
  collection: "Collections",
  item: "Items",
  currency: "Tokens",
  account: "Accounts"
};
export const DEFAULT_EXPANDED_SEARCH_RESULT_SECTIONS = ["collection", "currency", "item", "account"];
export function ExpandedSearchResultSections(t0) {
  const $ = _c(23);
  let renderResult;
  let rest;
  let sectionData;
  let selectedChain;
  let t1;
  if ($[0] !== t0) {
    ({
      sections: t1,
      sectionData,
      renderResult,
      selectedChain,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = renderResult;
    $[2] = rest;
    $[3] = sectionData;
    $[4] = selectedChain;
    $[5] = t1;
  } else {
    renderResult = $[1];
    rest = $[2];
    sectionData = $[3];
    selectedChain = $[4];
    t1 = $[5];
  }
  const sections = t1 === undefined ? DEFAULT_EXPANDED_SEARCH_RESULT_SECTIONS : t1;
  let t2;
  if ($[6] !== sectionData) {
    t2 = Object.values(sectionData).some(_temp);
    $[6] = sectionData;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const hasResults = t2;
  let t3;
  if ($[8] !== hasResults || $[9] !== renderResult || $[10] !== rest || $[11] !== sectionData || $[12] !== sections || $[13] !== selectedChain) {
    let t4;
    if ($[15] !== hasResults || $[16] !== renderResult || $[17] !== rest || $[18] !== sectionData || $[19] !== selectedChain) {
      t4 = section_0 => <ExpandedSearchResultSection doesParentHaveResults={hasResults} isLoading={sectionData[section_0]?.isLoading ?? false} key={section_0} renderResult={renderResult} results={sectionData[section_0]?.items ?? []} section={section_0} selectedChain={selectedChain} {...rest} />;
      $[15] = hasResults;
      $[16] = renderResult;
      $[17] = rest;
      $[18] = sectionData;
      $[19] = selectedChain;
      $[20] = t4;
    } else {
      t4 = $[20];
    }
    t3 = sections.map(t4);
    $[8] = hasResults;
    $[9] = renderResult;
    $[10] = rest;
    $[11] = sectionData;
    $[12] = sections;
    $[13] = selectedChain;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[21] !== t3) {
    t4 = <>{t3}</>;
    $[21] = t3;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  return t4;
}
function _temp(section) {
  return section.items.length > 0;
}